import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";
import { format } from 'date-fns'
import { getCommunications } from "../../../helpers/fakebackend_helper";

//Import Icons
import FeatherIcon from "feather-icons-react";


//i18n
import { withTranslation } from "react-i18next";

const NotificationDropdown = (props) => {
  const [communications, setCommunications] = useState({});

  
  useEffect(() => {
    getCommunications()
    .then((response) => {
    setCommunications(response)
    })
    .catch(err =>
      console.log(err));
 }, []);



  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <FeatherIcon icon="bell" className="icon-lg" />
          {/* <span className="badge bg-danger rounded-pill">5</span> */}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
              <div className="col-auto">
                <Link to="/comunicazione" className="small">
                  {" "}
                  Scopri di più
                </Link>
              </div>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
          {communications.length > 0 ? communications.map((communication)=>
          <>
            <Link to={`/comunicazione/${communication._id}`} className="text-reset notification-item" key={communication._id}>
              <div className="d-flex" key={communication._id}>
                <div className="avatar-sm me-3" key={communication._id}>
                  <span className="avatar-title bg-primary rounded-circle font-size-16" >
                    <i className="bx bx-comment" />
                  </span>
                </div>
                <div className="flex-grow-1" key={communication.title}>
                  <h6 className="mt-0 mb-1">
                  {communication.title}
                  </h6>
                  <div className="font-size-12 text-muted" key={communication.subtitle}>
                    <p className="mb-1">
                    {communication.subtitle}
                    </p>
                    <p className="mb-0" key={communication.updatedAt}>
                      <i className="mdi mdi-clock-outline" />{" "}
                      { format(new Date(communication.updatedAt), 'dd/mm/yyyy')}
                    </p>
                  </div>
                </div>
              </div>
            </Link>
            </>) :
            <div>
              <p className="m-3">Nessuna nuova comunicazione presente</p>
              </div>
            }
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              to="/comunicazione"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
              Scopri di più{" "}
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(NotificationDropdown);

NotificationDropdown.propTypes = {
  t: PropTypes.any,
};
